import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE from "./config";
import { useNavigate } from "react-router-dom";
import "./css/NfcPage.css";

const NfcPage = () => {
  const [analysisTypes, setAnalysisTypes] = useState([]);
  const [pipelinesByType, setPipelinesByType] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const typesRes = await axios.get(`${API_BASE}/analysis-types`);
        const pipelinesRes = await axios.get(`${API_BASE}/nfcore-pipelines`);

        setAnalysisTypes(typesRes.data);

        // Group pipelines by analysis_type
        const grouped = {};
        pipelinesRes.data.forEach((pipeline) => {
          const typeId = pipeline.analysis_type;
          if (!grouped[typeId]) grouped[typeId] = [];
          grouped[typeId].push(pipeline);
        });
        setPipelinesByType(grouped);
      } catch (err) {
        console.error("Error fetching NF-core data:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="nfc-page-container">
      <header className="nfc-header">
        <h2>Launch NF-CORE Pipelines</h2>
        <h4>Use the links to launch analysis of your choice</h4>
      </header>

      <div className="analysis-grid">
        {analysisTypes.map((type) => {
            const pipelines = pipelinesByType[type.id] || [];

            return (
                <div key={type.id} className="analysis-card">
                    <div className="analysis-type">{type.analysis_type}</div>

                    <div className="pipeline-buttons">
                        {pipelines.length > 0 ? (
                            pipelines.map((pipeline) => (
                                <button
                                    key={pipeline.id}
                                    className="pipeline-btn"
                                    onClick={() => navigate(`/pipeline-config/${pipeline.id}`)}
                                >
                                    {pipeline.pipeline_name}
                                </button>
                            ))
                        ) : (
                            <div className="coming-soon-text">Coming Soon</div>
                        )}
                    </div>
                </div>
            );
        })}
      </div>
    </div>
  );
};

export default NfcPage;
